<template>
    <div>
        <div>
            <label :for="label" class="m-0 cursor-pointer text-muted">
                <input hidden="hidden" :id="label" type="file"
                    accept="image/jpeg,image/png"
                    @change="handleFileChange()">
                <slot></slot>
            </label>
        </div>

        <modal ref="modal" size='lg' :has-footer="false">
            <div slot="title">
                Custom image
            </div>

            <div class="row">
                <div class="col-md-8">
                    <div class="result" :class="classTemp">
                    </div>
                </div>

                <div class="col-md-4 text-center" v-if="image">
                    Preview
                    <div class="mt-2">
                        <img :src="image" class="border rounded-circle">
                    </div>
                </div>
            </div>

            <div class="text-right mt-3" v-if="image">
                <button type="button" class="btn btn-default" @click="cancel">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click="save">
                    Crop image
                </button>
            </div>
        </modal>
    </div>
</template>

<script>
    import Cropper from 'cropperjs';
    import 'cropperjs/dist/cropper.min.css';

    export default {
        props: {
            label: {
                type: String,
                default: 'image'
            },
            width: {
                type: Number,
                default: 200
            },
            height: {
                type: Number,
                default: 200
            },
            event: {
                type: String,
                default: 'changed'
            }
        },

        data() {
            return {
                cropper: '',
                image: '',
                classTemp: `result__${new Date().getTime()}`
            }
        },

        methods: {
            handleFileChange() {
                if (event.target.files.length) {
                    this.$refs.modal.open();

                    let result = document.querySelector(`.${this.classTemp}`);

                    const reader = new FileReader();
                    reader.readAsDataURL(event.target.files[0]);
                    reader.onload = (event)=> {

                        let that = this;

                        if (event.target.result) {
                            // create new image
                            let img = document.createElement('img');
                            img.src = event.target.result;

                            // clean result before
                            result.innerHTML = '';

                            // append new image
                            result.appendChild(img);

                            // init cropper
                            this.cropper = new Cropper(img, {
                                dragMode: 'move',
                                aspectRatio: 1 / 1,
                                cropBoxResizable: false,
                                toggleDragModeOnDblclick: false,
                                crop(event) {
                                    that.croppie();
                                },
                                ready() {
                                    this.cropper.setCropBoxData({
                                        width: that.width,
                                        height: that.height
                                    });
                                }
                            });
                        }
                    };
                }
            },

            croppie(event) {
                this.image = this.cropper.getCroppedCanvas({
                    width: this.cropper.cropBoxData.width
                }).toDataURL();
            },

            cancel() {
                this.clear();
            },

            clear() {
                this.cropper = '';
                this.image = '';
                document.querySelector(`.${this.classTemp}`).innerHTML = '';
                document.querySelector(`#${this.label}`).value = '';
                this.$refs.modal.close();
            },

            save() {
                let file = this.cropper.getCroppedCanvas({
                    width: this.cropper.cropBoxData.width
                });

                let url = file.toDataURL();

                file.toBlob((blob) => {
                    let formData = new FormData();
                    formData.append('file', blob);

                    axios.post(this.$laroute.route('api.files.temp-image'), formData)
                        .then(({data}) => {
                            let name = data.path.split('/').pop();
                            this.$emit(this.event, data.path, url);
                        })
                        .catch((error) => console.log(error));
                });

                this.clear();
            },
        }
    }
</script>

<style lang="scss" scoped>
    .result {
        max-height: 300px;
    }
</style>
